import { useEffect, useState } from "react";
import CustomButton from "../../Components/CustomButton";
import Header from "../../Components/Header";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import ProfileDisplay from "../../Components/ProfileDisplay";
import usePagination from "../../Hooks/usePagination";
import { useGetPaymentLogsQuery } from "../../Redux/Apis/Package";
import { dateFormatter } from "../../Utils";
import CustomTable from "../../Components/CustomTable";
import "./style.css";

const headers = [
  {
    key: "id",
    title: "S.No",
  },
  {
    key: "name",
    title: "Profile Name",
  },
  {
    key: "subscription",
    title: "Subscription Name",
  },
  {
    key: "start_date",
    title: "Start Date",
  },
  {
    key: "end_date",
    title: "End Date",
  },
  {
    key: "amount",
    title: "Paid Amount",
  },
  {
    key: "actions",
    title: "",
  },
];

const PaymentLogs = () => {

  const [sortBy, setSortBy] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isFetching: isLoading } = useGetPaymentLogsQuery();

  useEffect(() => {
    document.title = 'The Turn At | Payment Logs';
  }, []);

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header title="Payment Logs" nofilters />
                {
                  isLoading ? <Loader /> :
                    <>
                      <div className="row mb-3">
                        <div className="col-12">
                          <CustomTable
                            headers={headers}
                            dateFilter={false}
                            filterSort={true}
                            perPage={true}
                            filterSortValue={sortBy}
                            setFilterSortValue={setSortBy}
                            filterFrom={from}
                            setFilterFrom={setFrom}
                            filterTo={to}
                            setFilterTo={setTo}
                            length={data?.data?.length}
                            nocheckbox
                          >
                            <tbody>
                              {data?.data?.map((item, index) => (
                                <tr key={item?.id}>
                                  <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                  <td>
                                    <ProfileDisplay
                                      name={`${item?.user?.name}`}
                                      email={`${item?.user?.email}`}
                                    />
                                  </td>
                                  <td>{item?.plan?.product?.name}</td>
                                  <td>{dateFormatter(item?.current_period_start * 1000)}</td>
                                  <td>{dateFormatter(item?.current_period_end * 1000)}</td>
                                  <td>$ {((item?.latest_invoice?.amount_paid / 100) || 0)}</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <CustomButton variant="primaryButton" text="View Invoice" className="mx-1" onClick={() => window.open(item?.latest_invoice?.hosted_invoice_url)} />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </CustomTable>
                        </div>
                      </div>
                    </>
                }
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
};

export default PaymentLogs
